/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Similar listings gallery experiment hook
 */
import { OptimizelyContext } from '@optimizely/react-sdk'
import { BetaFeature, isBetaFeatureEnabled, localStorageSingleton } from '@zcode/nr-utils'
import type { MaybeEmptyProperty } from '@zcode/state-type'
import type { Location } from 'history'
import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
const VARIATION = 'DETAIL_SIMILAR_LISTINGS_NAV_DESTINATION'

const hasBetaFlag = (location: Location) =>
  isBetaFeatureEnabled(location, BetaFeature.SIMILAR_LISTINGS_GALLERY)

/**
 * Determines whether we should display the "gallery" when navigating to a detail page from the similar listings module
 */
export const useIsGalleryExperiment = (entity?: MaybeEmptyProperty) => {
  const location = useLocation()
  const { optimizely } = useContext(OptimizelyContext)
  const isClickedSimilarListing = localStorageSingleton.getx('similarGroupId') === entity?.groupId

  return (
    isClickedSimilarListing &&
    (hasBetaFlag(location) ||
      ((!!entity?.hasMedia || !!entity?.hasImage) && optimizely?.activate(VARIATION) === 'on'))
  )
}
